import React from "react"
import clsx from "clsx"
import Masonry from "react-masonry-css"
import { AppLink } from "@ecom/ui/components/AppLink"

import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"

import Container from "@ecom/ui/components/Container"

import ArrowIcon from "./ArrowIcon"

import * as styles from "./otherOffers.module.scss"

const columnsObj = {
  default: 4,
  1279: 3,
  959: 2,
  599: 1,
}

export type Tags = {
  name: string
  seos?: {
    shortTitle: string
    url: string
  }[]
  pages?: {
    shortTitle: string
    url: string
  }[]
}

export type OtherOffersProps = {
  tags?: Tags[]
  title?: string
  breakpointColumnsObj?: any
  orderNum?: string
  variant?: "refin" | "standard"
  pageUrl?: string
}

const OtherOffers = ({
  tags,
  title,
  breakpointColumnsObj = columnsObj,
  orderNum,
  variant = "standard",
  pageUrl,
}: OtherOffersProps) => {
  let hasBeenCalled = false
  const handleClick = () => {
    if (!hasBeenCalled) {
      hasBeenCalled = true
      pushToDataLayer({
        event: "buttonClick",
        name: "dropdown_other_card",
        placement: "other_card",
      })
    }
  }
  return (
    <section className={clsx(styles.section, styles[variant])} data-exclude={orderNum}>
      <Container>
        <Accordion classes={{ root: clsx(styles.dropdown, styles[variant]) }}>
          <AccordionSummary
            onClick={handleClick}
            expandIcon={<ArrowIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            classes={{ root: styles.fixJumping }}
          >
            <h2 className={styles.title}>{title || "Другие предложения по кредитам"}</h2>
          </AccordionSummary>
          <AccordionDetails>
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className={styles.MasonryGrid}
              columnClassName={styles.MasonryGridColumn}
            >
              {tags?.map(({ name, seos, pages }) => (
                <div className={styles.item} key={name}>
                  <h4 className={styles.tagTitle}>{name}</h4>
                  <div>
                    {seos &&
                      seos.map((item) => {
                        const isDiffUrl = item?.url !== pageUrl
                        return (
                          item?.shortTitle &&
                          isDiffUrl && (
                            <div className={styles.tagBlock} key={item?.shortTitle + Math.random()}>
                              <AppLink
                                href={item?.url}
                                className={styles.tagShort}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item?.shortTitle}
                              </AppLink>
                            </div>
                          )
                        )
                      })}
                    {pages &&
                      pages.map(
                        (item) =>
                          item?.shortTitle && (
                            <div className={styles.tagBlock} key={item?.url}>
                              <AppLink
                                href={item?.url}
                                className={styles.tagShort}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item?.shortTitle}
                              </AppLink>
                            </div>
                          )
                      )}
                  </div>
                </div>
              ))}
            </Masonry>
          </AccordionDetails>
        </Accordion>
      </Container>
    </section>
  )
}

export default OtherOffers
